import Wall from '../../Entity/Wall.js'
import Vector from '../../Vector.js'
import Size from '../../Size.js'


export const TYPE_WALL_CHANGED = 'wall_changed'

class WallChanged {
    
    constructor(data) {
        this.data = data
    }
    
    handle(game) {
        const data = this.data;
        const size = new Size(data.width, data.height);
        const position = new Vector(data.x, data.y);
        
        let wall = null;
        const walls = game.getWalls();
        if(walls.hasId(data.id)) {
            wall = walls.getById(data.id);
        } else {
            console.log(position.x, position.y)
            wall = new Wall(data.id, size, position);
            walls.add(wall);
        }
        
        wall
            .setSize(size)
            .setPosition(position);
    }
    
}

export default WallChanged
